import Axios from "axios";

const engineOperators = {
    namespaced: true,
    state: {
        list: [],
        loaded: false,
        promise: null,
    },
    actions: {
        async loadList({state, commit}) {
            if (state.promise) {
                return state.promise;
            }

            let promise = Axios({
                url: '/api/v1/engine-operators',
                method: 'GET',
                params: {
                    limit: 10,
                    offset: 0,
                },
            }).then(resp => {
                const {items, pagination: {limit, offset, totalCount}} = resp.data.items;

                console.log(items, limit, offset, totalCount);

                commit('SET_LIST', items);
                commit('SET_LOADED', true);
            });

            commit('SET_PROMISE', promise);

            return promise;
        },
    },
    mutations: {
        SET_LIST: (state, payload) => {
            state.list = payload;
        },
        SET_LOADED: (state, payload) => {
            state.loaded = payload;
        },
        SET_PROMISE: (state, payload) => {
            state.promise = payload;
        },
    },
    getters: {
        list: (state) => state.list,
        loaded: (state) => state.loaded,
    }
};

export default engineOperators;
